import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'app/rootReducer'
import {
  isDebtorType1,
  isDebtorType2
} from 'reducers/activecase/activecaseSlice'
import {
  CourseInviteProvider,
  CourseStatus,
  CoursePaymentType,
  ForJointCaseOrders,
  CourseMethodType,
  CourseOrderItem,
  CourseTabTitle
} from 'share/domain/course'
import { CourseOrderStep } from 'share/domain/case'
import {
  getEmptyCourseOrderItem,
  getActiveTabCourseInvite,
  getFirstCourseOrderItem,
  getSecondCourseOrderItem
} from 'reducers/activecourse/activecourseSlice'
import CourseTabError from 'components/features/dashboard/course/tab/CourseTabError'
import CourseTabSecondComeBackLater from 'components/features/dashboard/course/tab/CourseTabSecondComeBackLater'
import CourseTabSecondNoCaseNumber from 'components/features/dashboard/course/tab/CourseTabSecondNoCaseNumber'
import CourseTabChooseCourse from 'components/features/dashboard/course/tab/CourseTabChooseCourse'
import CourseTabStart from 'components/features/dashboard/course/tab/CourseTabStart'
import CourseTabFinish from 'components/features/dashboard/course/tab/CourseTabFinish'
import CourseTabCanceled from 'components/features/dashboard/course/tab/CourseTabCanceled'
import CourseTabComplete from 'components/features/dashboard/course/tab/CourseTabComplete'
import CourseTabInvalidStateError from 'components/features/dashboard/course/tab/CourseTabInvalidStateError'
import CourseTabCourseOrderedForSpouse from 'components/features/dashboard/course/tab/CourseTabCourseOrderedForSpouse'
import CourseTabFirstCaseFiled from 'components/features/dashboard/course/tab/CourseTabFirstCaseFiled'
import CourseTabPlaceOrderUserVerification from 'components/features/dashboard/course/tab/CourseTabPlaceOrderUserVerification'
import CourseTabPlaceOrderCreateAccount from 'components/features/dashboard/course/tab/CourseTabPlaceOrderCreateAccount'
import CourseTabPlaceOrderAddSpouseOrJointDebtor from 'components/features/dashboard/course/tab/CourseTabPlaceOrderAddSpouseOrJointDebtor'
import CourseTabPlaceOrderChooseCourse from 'components/features/dashboard/course/tab/CourseTabPlaceOrderChooseCourse'
import CourseTabPlaceOrderError from 'components/features/dashboard/course/tab/CourseTabPlaceOrderError'
import CoursePlaceOrderLookupFoundCourse from 'components/features/dashboard/course/tab/CoursePlaceOrderLookupFoundCourse'

function CourseTabMain(): JSX.Element {
  const isDebtor1 = useSelector(isDebtorType1)
  const isDebtor2 = useSelector(isDebtorType2)
  const activeCase = useSelector((state: RootState) => state.activeCase)
  const activeCourse = useSelector((state: RootState) => state.activeCourse)
  const firstCourseOrderItem = useSelector(getFirstCourseOrderItem)
  const secondCourseOrderItem = useSelector(getSecondCourseOrderItem)
  const courseInvite = useSelector(getActiveTabCourseInvite)
  let courseTabSecondNoCaseNumberTitle = CourseTabTitle.FINISHED_FIRST_COURSE

  // check for second tab edge cases
  /*  console.log('isDebtor1 is ', isDebtor1)
  console.log('isDebtor2 is ', isDebtor2) */

  function getFirstCourseForJointCaseOrders(): number | null | undefined {
    if (isDebtor1) {
      return activeCase.matter?.debtor1FirstCourseForJointCaseOrders
    } else {
      return activeCase.matter?.debtor2FirstCourseForJointCaseOrders
    }
  }

  function getSecondCourseForJointCaseOrders(): number | null | undefined {
    if (isDebtor1) {
      return activeCase.matter?.debtor1SecondCourseForJointCaseOrders
    } else {
      return activeCase.matter?.debtor2SecondCourseForJointCaseOrders
    }
  }

  function getFirstCourseOrderStep(): number | null | undefined {
    if (isDebtor1) {
      return activeCase.matter?.debtor1FirstCourseOrderStep
    } else {
      return activeCase.matter?.debtor2FirstCourseOrderStep
    }
  }

  function getSecondCourseOrderStep(): number | null | undefined {
    if (isDebtor1) {
      return activeCase.matter?.debtor1SecondCourseOrderStep
    } else {
      return activeCase.matter?.debtor2SecondCourseOrderStep
    }
  }

  function shouldHaveData(): boolean {
    if (isDebtor1) {
      if (activeCourse.activeTab === 'first') {
        if (
          activeCase.matter?.debtor1FirstCourseForJointCaseOrders ==
          ForJointCaseOrders.OneCourseDebtor1Only
        ) {
          return true
        }
        if (
          activeCase.matter?.debtor1FirstCourseForJointCaseOrders ==
          ForJointCaseOrders.OneCourseTakingTogether
        ) {
          return true
        }
        if (
          activeCase.matter?.debtor1FirstCourseForJointCaseOrders ==
          ForJointCaseOrders.TwoCoursesTakingSeparately
        ) {
          return true
        }
      } else {
        if (
          activeCase.matter?.debtor1SecondCourseForJointCaseOrders ==
          ForJointCaseOrders.OneCourseDebtor1Only
        ) {
          return true
        }
        if (
          activeCase.matter?.debtor1SecondCourseForJointCaseOrders ==
          ForJointCaseOrders.OneCourseTakingTogether
        ) {
          return true
        }
        if (
          activeCase.matter?.debtor1SecondCourseForJointCaseOrders ==
          ForJointCaseOrders.TwoCoursesTakingSeparately
        ) {
          return true
        }
      }
    }

    if (isDebtor2) {
      if (activeCourse.activeTab === 'first') {
        if (
          activeCase.matter?.debtor2FirstCourseForJointCaseOrders ==
          ForJointCaseOrders.OneCourseDebtor2Only
        ) {
          return true
        }
        if (
          activeCase.matter?.debtor2FirstCourseForJointCaseOrders ==
          ForJointCaseOrders.OneCourseTakingTogether
        ) {
          return true
        }
        if (
          activeCase.matter?.debtor2FirstCourseForJointCaseOrders ==
          ForJointCaseOrders.TwoCoursesTakingSeparately
        ) {
          return true
        }
      } else {
        if (
          activeCase.matter?.debtor2SecondCourseForJointCaseOrders ==
          ForJointCaseOrders.OneCourseDebtor2Only
        ) {
          return true
        }
        if (
          activeCase.matter?.debtor2SecondCourseForJointCaseOrders ==
          ForJointCaseOrders.OneCourseTakingTogether
        ) {
          return true
        }
        if (
          activeCase.matter?.debtor2SecondCourseForJointCaseOrders ==
          ForJointCaseOrders.TwoCoursesTakingSeparately
        ) {
          return true
        }
      }
    }
    return false
  }

  function debtor1HasPlacedCourseOrder(): boolean {
    if (activeCourse.activeTab === 'first') {
      if (
        activeCase &&
        activeCase.matter &&
        activeCase.matter.debtor1HasPlacedFirstCourseOrder
      ) {
        return true
      }
      return false
    } else {
      if (
        activeCase &&
        activeCase.matter &&
        activeCase.matter.debtor1HasPlacedSecondCourseOrder
      ) {
        return true
      }
      return false
    }
  }

  function debtor1HasNotPlacedCourseOrder(): boolean {
    if (activeCourse.activeTab === 'first') {
      if (
        activeCase &&
        activeCase.matter &&
        !activeCase.matter.debtor1HasPlacedFirstCourseOrder
      ) {
        return true
      }
      return false
    } else {
      if (
        activeCase &&
        activeCase.matter &&
        !activeCase.matter.debtor1HasPlacedSecondCourseOrder
      ) {
        return true
      }
      return false
    }
  }

  function debtor2HasPlacedCourseOrder(): boolean {
    if (activeCourse.activeTab === 'first') {
      if (
        activeCase &&
        activeCase.matter &&
        activeCase.matter.debtor2HasPlacedFirstCourseOrder
      ) {
        return true
      }
      return false
    } else {
      if (
        activeCase &&
        activeCase.matter &&
        activeCase.matter.debtor2HasPlacedSecondCourseOrder
      ) {
        return true
      }
      return false
    }
  }

  function debtor2HasNotPlacedCourseOrder(): boolean {
    if (activeCourse.activeTab === 'first') {
      if (
        activeCase &&
        activeCase.matter &&
        !activeCase.matter.debtor2HasPlacedFirstCourseOrder
      ) {
        return true
      }
      return false
    } else {
      if (
        activeCase &&
        activeCase.matter &&
        !activeCase.matter.debtor2HasPlacedSecondCourseOrder
      ) {
        return true
      }
      return false
    }
  }

  function hasPlacedCourseOrder(): boolean {
    if (isDebtor1) {
      return debtor1HasPlacedCourseOrder()
    } else {
      return debtor2HasPlacedCourseOrder()
    }
  }

  function hasNotPlacedCourseOrder(): boolean {
    if (isDebtor1) {
      return debtor1HasNotPlacedCourseOrder()
    } else {
      return debtor2HasNotPlacedCourseOrder()
    }
  }

  const isCanceledClientPays =
    !courseInvite &&
    activeCase.isActiveCase &&
    activeCase.matter?.status.toLowerCase() === 'pre-filing' &&
    !activeCourse.selectedCourse &&
    activeCourse.isActiveCourse &&
    activeCourse.orderData.length === 0 &&
    activeCourse.inviteData?.[0]?.courseNumber !== activeCourse.activeTab

  function isInvalidCourseData(): boolean {
    if (activeCourse) {
      if (
        activeCourse.inviteData.length === 0 &&
        activeCourse.orderData.length === 0
      ) {
        return true
      }
    }
    return false
  }

  function getCourseOrderForSpouseStatusFirst(): CourseStatus {
    if (activeCase.matter) {
      if (activeCase.matter.isJoint) {
        if (
          getFirstCourseForJointCaseOrders() &&
          getFirstCourseForJointCaseOrders() ===
            ForJointCaseOrders.OneCourseDebtor1Only
        ) {
          if (isDebtor2) {
            return CourseStatus.CourseOrderedForSpouse
          }
        } else if (
          getFirstCourseForJointCaseOrders() &&
          getFirstCourseForJointCaseOrders() ===
            ForJointCaseOrders.OneCourseDebtor2Only
        ) {
          if (isDebtor1) {
            return CourseStatus.CourseOrderedForSpouse
          }
        }
      }
    }
    return CourseStatus.Unknown
  }

  function getCourseOrderForSpouseStatusSecond(): CourseStatus {
    if (activeCase.matter) {
      if (activeCase.matter.isJoint) {
        if (
          getSecondCourseForJointCaseOrders() &&
          getSecondCourseForJointCaseOrders() ===
            ForJointCaseOrders.OneCourseDebtor1Only
        ) {
          if (isDebtor2) {
            return CourseStatus.CourseOrderedForSpouse
          }
        } else if (
          getSecondCourseForJointCaseOrders() &&
          getSecondCourseForJointCaseOrders() ===
            ForJointCaseOrders.OneCourseDebtor2Only
        ) {
          if (isDebtor1) {
            return CourseStatus.CourseOrderedForSpouse
          }
        }
      }
    }
    return CourseStatus.Unknown
  }

  function isJointSecondCourseTakeSeperately() {
    if (activeCase.matter) {
      if (activeCase.matter.isJoint) {
        if (
          getSecondCourseForJointCaseOrders() &&
          getSecondCourseForJointCaseOrders() ===
            ForJointCaseOrders.TwoCoursesTakingSeparately
        ) {
          return true
        }
      }
    }
    return false
  }

  function isJointSecondCourseDebtor1Only() {
    if (activeCase.matter) {
      if (activeCase.matter.isJoint) {
        if (
          getSecondCourseForJointCaseOrders() &&
          (getSecondCourseForJointCaseOrders() ===
            ForJointCaseOrders.OneCourseDebtor1Only ||
            getSecondCourseForJointCaseOrders() ===
              ForJointCaseOrders.OneCourseTakingTogether)
        ) {
          return true
        }
      }
    }
    return false
  }

  function isJointSecondCourseDebtor2Only() {
    if (activeCase.matter) {
      if (activeCase.matter.isJoint) {
        if (
          getSecondCourseForJointCaseOrders() &&
          getSecondCourseForJointCaseOrders() ===
            ForJointCaseOrders.OneCourseDebtor2Only
        ) {
          return true
        }
      }
    }
    return false
  }

  function ShouldHaveTakenFirstCourse(): boolean {
    const secondCourseStatus = getCourseOrderForSpouseStatusSecond()
    if (secondCourseStatus === CourseStatus.CourseOrderedForSpouse) {
      return false
    }

    if (
      activeCase.matter &&
      (activeCase.matter?.status.toLowerCase() === 'filed' ||
        activeCase.matter?.status.toLowerCase() === 'complete')
    ) {
      return false
    }

    const courseStatus = getCourseOrderForSpouseStatusFirst()
    // if CourseStatus is equal to CourseOrderedForSpouse then there will never be a non null firstCourseOrderItem
    if (courseStatus === CourseStatus.Unknown) {
      return true
    } else {
      return false
    }
  }

  function secondTabFirstCourseNotOrderedYet(): boolean {
    if (
      activeCourse.activeTab === 'second' &&
      !firstCourseOrderItem &&
      activeCase.matter &&
      activeCase.matter?.status.toLowerCase() === 'pre-filing'
    ) {
      if (
        isJointSecondCourseTakeSeperately() ||
        isJointSecondCourseDebtor1Only() ||
        isJointSecondCourseDebtor2Only()
      ) {
        if (ShouldHaveTakenFirstCourse()) {
          return true
        } else {
          return false
        }
      }
      return true
    }
    return false
  }

  function secondTabFirstCourseNotYetCompleteCondition(): boolean {
    if (
      activeCase.matter &&
      (activeCase.matter?.status.toLowerCase() === 'filed' ||
        activeCase.matter?.status.toLowerCase() === 'complete')
    ) {
      return false
    }

    if (
      activeCourse.activeTab === 'second' &&
      firstCourseOrderItem &&
      firstCourseOrderItem.courseStatus !== CourseStatus.Complete &&
      firstCourseOrderItem.courseStatus !==
        CourseStatus.CompleteCertificateManuallyUploaded
    ) {
      if (
        isJointSecondCourseTakeSeperately() ||
        isJointSecondCourseDebtor1Only() ||
        isJointSecondCourseDebtor2Only()
      ) {
        if (ShouldHaveTakenFirstCourse()) {
          return true
        } else {
          return false
        }
      }

      return true
    }
    return false
  }

  function secondTabFirstCourseCompleteNotYetFiledCondition(): boolean {
    if (isDebtor1 && isJointSecondCourseDebtor1Only()) {
      if (
        activeCourse.activeTab === 'second' &&
        activeCase.matter &&
        activeCase.matter?.status.toLowerCase() === 'pre-filing'
      ) {
        return true
      }
    }
    if (isDebtor2 && isJointSecondCourseDebtor2Only()) {
      if (
        activeCourse.activeTab === 'second' &&
        activeCase.matter &&
        activeCase.matter?.status.toLowerCase() === 'pre-filing'
      ) {
        return true
      }
    }

    if (isDebtor2 && isJointSecondCourseDebtor1Only()) {
      if (activeCourse.activeTab === 'second') {
        return false
      }
    }

    if (
      activeCourse.activeTab === 'second' &&
      firstCourseOrderItem &&
      (firstCourseOrderItem.courseStatus === CourseStatus.Complete ||
        firstCourseOrderItem.courseStatus ===
          CourseStatus.CompleteCertificateManuallyUploaded) &&
      !secondCourseOrderItem &&
      activeCase.matter &&
      activeCase.matter?.status.toLowerCase() === 'pre-filing'
    ) {
      if (isJointSecondCourseTakeSeperately()) {
        if (ShouldHaveTakenFirstCourse()) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
    return false
  }

  function secondTabFirstCourseCompleteCaseNumberNotGeneratedCondition(): boolean {
    if (isDebtor1 && isJointSecondCourseDebtor1Only()) {
      if (
        activeCourse.activeTab === 'second' &&
        activeCase.matter &&
        (activeCase.matter.caseNumber === null ||
          activeCase.matter.caseNumber.length === 0)
      ) {
        return true
      }
    }

    if (isDebtor2 && isJointSecondCourseDebtor2Only()) {
      if (
        activeCourse.activeTab === 'second' &&
        activeCase.matter &&
        (activeCase.matter.caseNumber === null ||
          activeCase.matter.caseNumber.length === 0)
      ) {
        return true
      }
    }

    if (isDebtor2 && isJointSecondCourseDebtor1Only()) {
      if (activeCourse.activeTab === 'second') {
        return false
      }
    }

    if (
      activeCourse.activeTab === 'second' &&
      firstCourseOrderItem &&
      (firstCourseOrderItem.courseStatus === CourseStatus.Complete ||
        firstCourseOrderItem.courseStatus ===
          CourseStatus.CompleteCertificateManuallyUploaded) &&
      !secondCourseOrderItem &&
      activeCase.matter &&
      (activeCase.matter.caseNumber === null ||
        activeCase.matter.caseNumber.length === 0)
    ) {
      if (isJointSecondCourseTakeSeperately()) {
        if (ShouldHaveTakenFirstCourse()) {
          return true
        } else {
          return false
        }
      }
      return true
    }
    return false
  }

  function secondTabCaseFiledButCaseNumberNotGeneratedCondition(): boolean {
    if (
      activeCourse.activeTab === 'second' &&
      activeCase.matter &&
      (activeCase.matter?.status.toLowerCase() === 'filed' ||
        activeCase.matter?.status.toLowerCase() === 'complete') &&
      (activeCase.matter.caseNumber === null ||
        activeCase.matter.caseNumber.length === 0)
    ) {
      return true
    }
    return false
  }

  function isCasePreFiled(): boolean {
    if (
      activeCase &&
      activeCase.matter &&
      activeCase.matter.status &&
      activeCase.matter?.status.toLowerCase() === 'pre-filing'
    ) {
      return true
    }
    return false
  }

  function isCaseFiledAndHasCaseNumber(): boolean {
    if (
      activeCase &&
      activeCase.matter &&
      activeCase.matter.status &&
      (activeCase.matter.status.toLowerCase() === 'filed' ||
        activeCase.matter.status.toLowerCase() === 'complete') &&
      activeCase.matter.caseNumber &&
      activeCase.matter.caseNumber.length > 0
    ) {
      return true
    }

    return false
  }

  function hasCourseTypePhoneCompletedForcedMarch(
    course: CourseOrderItem,
    isCanceledClientPays: boolean
  ) {
    // if online we do not care about phone forced march check
    if (course.courseMethod === CourseMethodType.Online) {
      return true
    }
    // if cancelled or expired do not care about phone forced march check
    if (
      courseStatus === CourseStatus.Canceled ||
      courseStatus === CourseStatus.Expired ||
      isCanceledClientPays
    ) {
      return true
    }

    // if completed we do not care about phone forced march check
    if (
      courseStatus === CourseStatus.Complete ||
      courseStatus === CourseStatus.CompleteCertificateManuallyUploaded
    ) {
      return true
    }

    // do not move off the start screen until after they complete phone forced march
    if (
      !course.verifiedDetails ||
      !course.acceptedDisclosureAgreement ||
      !course.shownCourseInstructions
    ) {
      return false
    }
    return true
  }

  // no first course order exists for matter
  if (
    hasNotPlacedCourseOrder() &&
    activeCourse.activeTab === 'first' &&
    isCasePreFiled()
  ) {
    if (getFirstCourseOrderStep() == CourseOrderStep.UserVerification) {
      return <CourseTabPlaceOrderUserVerification />
    } else if (getFirstCourseOrderStep() == CourseOrderStep.CreateAccount) {
      return <CourseTabPlaceOrderCreateAccount />
    } else if (
      getFirstCourseOrderStep() == CourseOrderStep.AddSpouseOrJointDebtor
    ) {
      return <CourseTabPlaceOrderAddSpouseOrJointDebtor />
    } else if (getFirstCourseOrderStep() == CourseOrderStep.ChooseCourse) {
      return <CourseTabPlaceOrderChooseCourse />
    } else if (getFirstCourseOrderStep() == CourseOrderStep.LookupFoundCourse) {
      return <CoursePlaceOrderLookupFoundCourse course={firstCourseOrderItem} />
    }
    return <CourseTabPlaceOrderError />
  }

  // no second course order exists for matter
  if (
    hasNotPlacedCourseOrder() &&
    activeCourse.activeTab === 'second' &&
    isCaseFiledAndHasCaseNumber()
  ) {
    if (getSecondCourseOrderStep() == CourseOrderStep.UserVerification) {
      return <CourseTabPlaceOrderUserVerification />
    } else if (getSecondCourseOrderStep() == CourseOrderStep.CreateAccount) {
      return <CourseTabPlaceOrderCreateAccount />
    } else if (
      getSecondCourseOrderStep() == CourseOrderStep.AddSpouseOrJointDebtor
    ) {
      return <CourseTabPlaceOrderAddSpouseOrJointDebtor />
    } else if (getSecondCourseOrderStep() == CourseOrderStep.ChooseCourse) {
      return <CourseTabPlaceOrderChooseCourse />
    } else if (
      getSecondCourseOrderStep() == CourseOrderStep.LookupFoundCourse
    ) {
      return (
        <CoursePlaceOrderLookupFoundCourse course={secondCourseOrderItem} />
      )
    } else if (
      getSecondCourseOrderStep() == CourseOrderStep.CourseOrderFailed
    ) {
      return <CourseTabPlaceOrderError />
    }
  }

  console.log('shouldHaveData', shouldHaveData())
  console.log('hasPlacedCourseOrder', hasPlacedCourseOrder())
  // if has placed a course order and the data is missing the course data is not valid then show error page
  if (hasPlacedCourseOrder() && shouldHaveData() && isInvalidCourseData()) {
    return <CourseTabError />
  }

  // user on second tab but no first course ordered yet
  if (secondTabFirstCourseNotOrderedYet()) {
    return (
      <CourseTabSecondComeBackLater title={CourseTabTitle.TAKE_FIRST_COURSE} />
    )
  }

  // user on second tab. First course started but not yet completed
  if (secondTabFirstCourseNotYetCompleteCondition()) {
    return (
      <CourseTabSecondComeBackLater title={CourseTabTitle.TAKE_FIRST_COURSE} />
    )
  }

  // user on second tab. First course completed but case is not yet filed
  if (secondTabFirstCourseCompleteNotYetFiledCondition()) {
    if (
      (isDebtor1 && isJointSecondCourseDebtor1Only()) ||
      (isDebtor2 && isJointSecondCourseDebtor2Only())
    ) {
      courseTabSecondNoCaseNumberTitle = CourseTabTitle.TAKE_SECOND_COURSE
      return (
        <CourseTabSecondComeBackLater
          title={courseTabSecondNoCaseNumberTitle}
        />
      )
    }
    return (
      <CourseTabSecondComeBackLater
        title={CourseTabTitle.FINISHED_FIRST_COURSE}
      />
    )
  }

  // user on second tab. First course completed but a case number has not yet been generated.
  if (secondTabFirstCourseCompleteCaseNumberNotGeneratedCondition()) {
    if (
      (isDebtor1 && isJointSecondCourseDebtor1Only()) ||
      (isDebtor2 && isJointSecondCourseDebtor2Only())
    ) {
      courseTabSecondNoCaseNumberTitle = CourseTabTitle.TAKE_SECOND_COURSE
      return (
        <CourseTabSecondNoCaseNumber title={courseTabSecondNoCaseNumberTitle} />
      )
    }

    return (
      <CourseTabSecondNoCaseNumber title={courseTabSecondNoCaseNumberTitle} />
    )
  }

  if (secondTabCaseFiledButCaseNumberNotGeneratedCondition()) {
    courseTabSecondNoCaseNumberTitle = CourseTabTitle.TAKE_SECOND_COURSE
    return (
      <CourseTabSecondNoCaseNumber title={courseTabSecondNoCaseNumberTitle} />
    )
  }

  // initialize for main logic
  let courseStatus = CourseStatus.ChooseCourse
  let coursePaymentType = CoursePaymentType.ClientPays
  let courseProviderList: CourseInviteProvider[] = []
  let courseOrderItem = getEmptyCourseOrderItem()

  if (activeCourse.activeTab === 'first') {
    if (firstCourseOrderItem) {
      courseStatus = firstCourseOrderItem.courseStatus
      coursePaymentType = firstCourseOrderItem.coursePaymentType
      courseOrderItem = firstCourseOrderItem
      const courseOrderForSpouseFirst = getCourseOrderForSpouseStatusFirst()
      if (courseOrderForSpouseFirst === CourseStatus.CourseOrderedForSpouse) {
        courseStatus = CourseStatus.CourseOrderedForSpouse
      }
    } else {
      if (courseInvite) {
        if (courseInvite.coursePaymentType) {
          coursePaymentType = courseInvite.coursePaymentType
        }
        if (courseInvite.courseProviders) {
          courseProviderList = courseInvite.courseProviders
        }
      }
      const courseOrderForSpouseFirst = getCourseOrderForSpouseStatusFirst()
      if (courseOrderForSpouseFirst === CourseStatus.CourseOrderedForSpouse) {
        courseStatus = CourseStatus.CourseOrderedForSpouse
      }
    }
  } else {
    // second tab active
    if (secondCourseOrderItem) {
      courseStatus = secondCourseOrderItem.courseStatus
      coursePaymentType = secondCourseOrderItem.coursePaymentType
      courseOrderItem = secondCourseOrderItem
      const courseOrderForSpouseSecond = getCourseOrderForSpouseStatusSecond()
      if (courseOrderForSpouseSecond === CourseStatus.CourseOrderedForSpouse) {
        courseStatus = CourseStatus.CourseOrderedForSpouse
      }
    } else {
      courseStatus = CourseStatus.ChooseCourse
      if (courseInvite) {
        if (courseInvite.coursePaymentType) {
          coursePaymentType = courseInvite.coursePaymentType
        }
        if (courseInvite.courseProviders) {
          courseProviderList = courseInvite.courseProviders
        }
      }
      const courseOrderForSpouseSecond = getCourseOrderForSpouseStatusSecond()
      if (courseOrderForSpouseSecond === CourseStatus.CourseOrderedForSpouse) {
        courseStatus = CourseStatus.CourseOrderedForSpouse
      }
    }
  }

  if (courseStatus === CourseStatus.CourseOrderedForSpouse) {
    return <CourseTabCourseOrderedForSpouse />
  } else if (
    activeCourse.activeTab === 'first' &&
    activeCase.matter &&
    (activeCase.matter?.status.toLowerCase() === 'filed' ||
      activeCase.matter?.status.toLowerCase() === 'complete') &&
    courseStatus !== CourseStatus.Complete
  ) {
    return <CourseTabFirstCaseFiled title={CourseTabTitle.TAKE_SECOND_COURSE} />
  } else if (
    !isCanceledClientPays &&
    courseStatus === CourseStatus.ChooseCourse
  ) {
    return (
      <CourseTabChooseCourse
        coursePaymentType={coursePaymentType}
        courseProviderList={courseProviderList}
      />
    )
  } else if (
    courseStatus === CourseStatus.PendingRegistration ||
    courseStatus === CourseStatus.PendingRegistrationPhone ||
    !hasCourseTypePhoneCompletedForcedMarch(
      courseOrderItem,
      isCanceledClientPays
    )
  ) {
    return (
      <CourseTabStart
        currentTab={activeCourse.activeTab}
        course={courseOrderItem}
      />
    )
  } else if (
    courseStatus === CourseStatus.PendingCourseStarted ||
    courseStatus === CourseStatus.PendingCertification ||
    courseStatus === CourseStatus.PendingNotStarted ||
    courseStatus === CourseStatus.PendingNotStartedPhone
  ) {
    return (
      <CourseTabFinish
        currentTab={activeCourse.activeTab}
        course={courseOrderItem}
      />
    )
  } else if (
    courseStatus === CourseStatus.Canceled ||
    courseStatus === CourseStatus.Expired ||
    isCanceledClientPays
  ) {
    return <CourseTabCanceled course={courseOrderItem} />
  } else if (
    courseStatus === CourseStatus.Complete ||
    courseStatus === CourseStatus.CompleteCertificateManuallyUploaded
  ) {
    return (
      <CourseTabComplete
        currentTab={activeCourse.activeTab}
        course={courseOrderItem}
      />
    )
  }
  console.log('course tab invalid state error ' + courseStatus)
  console.dir(courseStatus)
  return <CourseTabInvalidStateError />
}

export default CourseTabMain
